let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("Wowvf"), load("ffEVr"), load("62AD8")]).then(() => parcelRequire('2JGhm'));